<script setup lang="ts">
  import { onBeforeUnmount, onMounted, ref, watch } from "vue";
  import { EditorView, basicSetup } from "codemirror";
  import { html } from "@codemirror/lang-html";
  import { css } from "@codemirror/lang-css";

  const props = defineProps<{ language: "html" | "css" }>();
  const model = defineModel<string>({ default: "" });

  const container = ref<HTMLElement | null>(null);
  let view: EditorView | null = null;

  onMounted(() => {
    view = new EditorView({
      doc: model.value,
      parent: container.value!,
      extensions: [
        basicSetup,
        props.language === "html" ? html() : css(),
        EditorView.lineWrapping,
        EditorView.theme({ "&": { height: "100%" }, ".cm-scroller": { overflow: "auto" } }),
        EditorView.updateListener.of((update) => {
          if (update.docChanged) model.value = update.state.doc.toString();
        }),
      ],
    });
  });

  watch(model, (value) => {
    if (!view || value === view.state.doc.toString()) return;
    view.dispatch({ changes: { from: 0, to: view.state.doc.length, insert: value } });
  });

  onBeforeUnmount(() => view?.destroy());
</script>

<template>
  <div
    ref="container"
    class="h-full min-h-0 overflow-hidden rounded-md border border-border bg-background font-mono text-xs [&_.cm-editor.cm-focused]:outline-none" />
</template>
